module.exports = __webpack_public_path__ + "static/media/ico-social08.81bf5f98.svg";